var Flickity = require('flickity');
var Flickity = require('flickity-bg-lazyload');

// import mediabox from 'mediabox';
// import 'mediabox/dist/mediabox.min.css'


if(document.querySelector('.inicio') != null) {
    // mediabox('.inicio .video');

    // WAMediaBox.bind(document.querySelector(".inicio .video"));
    require("./inicio/soluciones")
    require("./inicio/covid")

}